<template>
  <div class="open-app-display">
    <sub-menu :activeNum="2"></sub-menu>
    <div class="business-title">
      <button class="addapp" @click="openCreateBox" v-if="loaded && ytboxList.length > 0">
        <span class="icon-plus"></span>
        <span class="text">申请优图盒子授权</span>
      </button>
    </div>
    <div v-if="loaded && ytboxList.length > 0">
      <div class="app-list" v-for="(boxItem, index) in ytboxList" :key="index">
        <div class="header">
          <div class="border" :class="{'border-test': boxItem.applytype == BoxApplyKeyType.TEST}"></div>
          <div class="thead-title">
            <div class="app-title">
              <span>优图盒子</span>
              <div class="status" :class="{'status-test': boxItem.applytype == BoxApplyKeyType.TEST, 'status-normal': boxItem.applytype == BoxApplyKeyType.FORMAL}"></div>
            </div>
            <div class="check"
              :class="applyStatusHelper.common.calculateStyle(boxItem.status, ['checking', 'check-success', 'check-fail'])">
              <div class="status-result">
                {{applyStatusHelper.common.displayText(boxItem.status)}}
              </div>
              <div class="review-info">
                <div class="status-item-text" v-if="boxItem.status == BoxStatusKey.VERIFY_FAIL ||
                  applyStatusHelper.common.containStatus(boxItem.status, [BoxStatusKey.FORMAL_VERIFY_FAIL])">
                  <span class="status-item-label">审核失败原因：</span>
                  <span class="status-item-reason">{{boxItem.reason}}</span>
                </div>
                <div class="status-time-appid"
                  :class="{'disable-to-use' : applyStatusHelper.common.claculateExpirationStatus(boxItem.status)}">
                  <span v-if="applyStatusHelper.common.containStatus(boxItem.status, [BoxStatusKey.FORMAL_VERIFY_SUCCESS, BoxStatusKey.FORMAL_AUTH_OVER])">
                    <span>授权时间: {{boxItem.validbegin}} - {{boxItem.validend}}</span>
                  </span>
                  <span v-else>
                    <span v-if="applyStatusHelper.common.containStatus(boxItem.status, [BoxStatusKey.VERIFY_SUCCESS, BoxStatusKey.AUTH_OVER])">
                      测试时间: {{boxItem.validbegin}} - {{boxItem.validend}}
                    </span>
                  </span>
                </div>
                <div class="status-time-appid">
                  <!-- 新增AppId -->
                  <span v-if="boxItem.appid != ''">App ID: {{boxItem.appid}}</span>
                  <span class="secret appid" v-if="boxItem.secretkey != ''">SecretKey: {{boxItem.secretkey}}</span>
                </div>
              </div>
            </div>
          </div>
          <button
            v-if="(boxItem.status == YtboxStatusKey.VERIFY_SUCCESS || boxItem.status == YtboxStatusKey.AUTH_OVER) &&
            boxItem.applytype == YtboxApplyKeyType.TEST"
            class="g-btn-view private-to-formal"
            @click="handleChangeToFormalBox(boxItem)">申请正式授权</button>
          <div class="btn-group">
            <button class="app-del-btn"
              v-if="!applyStatusHelper.common.containStatus(boxItem.status, [YtboxStatusKey.VERIFYING, YtboxStatusKey.FORMAL_VERIFYING])"
              @click="handleDeleteBox(boxItem)">删除</button>
          </div>
        </div>
        <div class="app-info"
          :class="{'app-view-fail': boxItem.status == BoxStatusKey.VERIFY_FAIL ||
          applyStatusHelper.common.containStatus(boxItem.status, [BoxStatusKey.FORMAL_VERIFY_FAIL])}">
          <div class="app-info-row">
            <div class="app-info-container">
              <div class="app-label app-label-left">申请时间:</div>
              <div class="app-value app-value-left">{{boxItem.optime}}</div>
            </div>
          </div>
          <template v-if="boxItem.scope === JoinWay.EXTERNAL">
            <div class="app-info-row">
              <div class="app-info-container">
                <div class="app-label  app-label-left" >企业名称:</div>
                <div class="app-value app-value-left app-hide-text" :title="boxItem.extname">{{boxItem.extname}}</div>
              </div>
              <div class="app-info-container">
                <div class="app-label app-label-right">企业网址:</div>
                <div class="app-value app-value-right app-hide-text" :title="boxItem.exturl">{{boxItem.exturl}}</div>
              </div>
            </div>
            <div class="app-info-row">
              <div class="app-info-container">
                <div class="app-label  app-label-left">优图接口人邮箱:</div>
                <div class="app-value app-value-left app-hide-text" :title="boxItem.ytcontact">{{boxItem.ytcontact}}</div>
              </div>
              <div class="app-info-container">
                <div class="app-label app-label-right">业务接口人及联系方式:</div>
                <div class="app-value app-value-right app-hide-text" :title="boxItem.peercontact">{{boxItem.peercontact}}</div>
              </div>
            </div>
            <div class="app-info-row">
              <div class="app-info-container">
                <div class="app-label  app-label-left">营业执照:</div>
                <div class="app-value app-value-left">
                  <a v-if="boxItem.extlicense" target="_blank" :href="boxItem.extlicense" class="business-licence">营业执照</a>
                  <a v-else>--</a>
                </div>
              </div>
              <div class="app-info-container" v-show="boxItem.applytype == BoxApplyKeyType.FORMAL">
                <div class="app-label app-label-right">合同文件:</div>
                <div class="app-value app-value-right">
                  <a target="_blank" :href="boxItem.contract" class="business-licence business-contact">合同文件</a>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="app-info-row">
              <div class="app-info-container">
                <div class="app-label app-label-left">优图接口人邮箱:</div>
                <div class="app-value app-value-left app-hide-text" :title="boxItem.ytcontact">{{boxItem.ytcontact}}</div>
              </div>
              <div class="app-info-container">
                <div class="app-label app-label-right">业务接口人及联系方式:</div>
                <div class="app-value app-value-right app-hide-text" :title="boxItem.peercontact">{{boxItem.peercontact}}</div>
              </div>
            </div>
            <div class="app-info-row">
              <div class="app-info-container">
                <div class="app-label app-label-left">业务所属部门:</div>
                <div class="app-value app-value-left app-hide-text" :title="boxItem.intdept">{{boxItem.intdept}}</div>
              </div>
              <div class="app-info-container" v-show="boxItem.applytype == YtboxApplyKeyType.FORMAL">
                <div class="app-label app-label-right">合作备案:</div>
                <div class="app-value app-value-right">
                  <a target="_blank" :href="boxItem.contract" class="business-licence business-contact">合作备案</a>
                </div>
              </div>
            </div>
          </template>
          <div class="app-info-row">
            <div class="app-info-container">
              <div class="app-label app-label-left">应用场景:</div>
              <div class="app-value desc">
                <description-folder :content="boxItem.scene" />
              </div>
            </div>
          </div>
        </div>
        <div class="bind-list-container"
          v-if="applyStatusHelper.common.isDeviceVisible(boxItem.status)">
          <div class="bind-title app-label">绑定设备列表:</div>
          <div v-if="applyStatusHelper.common.isDeviceEditable(boxItem.status)" class="bind-button" @click="bindDeviceToYoutubox(boxItem)">绑定设备</div>
          <div v-if="applyStatusHelper.common.isDeviceEditable(boxItem.status)" class="bind-button-batch" @click="bindGroupDeviceToYoutubox(boxItem)">批量绑定设备</div>
          <div class="bind-content">
            <table class="detail-chart">
              <thead>
                <tr>
                  <th>设备号</th>
                  <th>设备状态</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody class="scrollbar"  v-if="boxItem.devices && boxItem.devices.length > 0">
                <tr v-for="(deviceItem, index) in boxItem.devices" :key="index">
                  <td class="device-number" :title="deviceItem.devno">{{deviceItem.devno}}</td>
                  <td>
                    <span v-if="deviceItem.devno" :class="[ deviceItem.status == DeviceStatus.INACTIVE ?  'activated' :'created']">
                      <span class="point"></span>
                      {{ deviceItem.status == DeviceStatus.INACTIVE ? `已激活至${deviceItem.end_time}` : '未激活' }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="delete-button"
                      @click="handleDeleteDevice(boxItem, deviceItem)"
                      v-if="deviceItem.status != DeviceStatus.INACTIVE && deviceItem.devno">
                      删除
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="platform-table">
              <div class="platform-column statics">
                <div class="title">统计</div>
                <div class="content" v-if="boxItem.deviceStatistics">
                  <div :title="boxItem.deviceStatistics[DeviceAuth.AUTH]">
                    {{boxItem.deviceStatistics[DeviceAuth.AUTH]}}
                  </div>
                  <div :title="boxItem.deviceStatistics[DeviceAuth.ADD]">
                    {{boxItem.deviceStatistics[DeviceAuth.ADD]}}
                  </div>
                  <div :title="boxItem.deviceStatistics[DeviceAuth.ACTIVE]">
                    {{boxItem.deviceStatistics[DeviceAuth.ACTIVE]}}
                  </div>
                </div>
                <div class="content" v-else>
                  已授权0台<br>
                  已添加0台<br>
                  已激活0台<br>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mail-receiver">
          <div class="">
            <div class="title-mail">邮件列表:</div>
            <div class="mail-row">
              <div class="receiver-info" :title="boxItem.mailreceiver">{{boxItem.mailreceiver ? boxItem.mailreceiver : '授权到期前会邮件提醒，如有多个接收人请以；分隔'}}</div>
            </div>
            <div class="save-row">
              <el-button @click="showMailReceiverVisible(boxItem)">修改</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="business-empty" v-if="loaded && ytboxList.length == 0">
      <div class="business-empty-icon"></div>
      <div class="business-empty-text">
        您还没有优图盒子授权<br>
        单击“申请优图盒子授权”按钮，申请优图盒子授权
      </div>
      <button class="addapp" @click="$router.transfer(RouteKey.OPEN_YOUTU_BOX_CREATOR)">
        <span class="icon-plus"></span>
        <span class="text">申请优图盒子授权</span>
      </button>
    </div>
    <!-- 添加设备 -->
    <el-dialog
      title="添加设备"
      :visible.sync="addDeviceVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="700px">
      <div class="add-device-form">
        <el-form :model="addDeviceValidateData" ref="deviceForm">
          <el-form-item prop="devno" label="设备号"
            :rules="[{validator: validateDevno, trigger: ['change', 'blur']}]">
            <el-input v-model="addDeviceValidateData.devno" placeholder="请输入设备号" :maxlength="100"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmBindDevice()">确 定</el-button>
        <el-button @click="addDeviceVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 批量添加设备 -->
    <el-dialog
      title="批量添加设备"
      :visible.sync="groupAddDeviceVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :before-close="cancleBindGroupDevice"
      width="700px"
      class="device-dialog">
      <div class="add-device-form">
        <el-form ref="groupAddDeviceValidateData">
          <el-form-item label="* 添加文件" ref="deviceGroupFile">
            <form-item-upload-file
              :validateFile="validateFile"
              :ErrorName="ErrorName"
              :dialogVisible="groupAddDeviceVisible"
              :NeedConfirm="false"
              :formatCSV="true"
              :twentyM="true"
              @validateInfoResult="deviceValidateResult">
            </form-item-upload-file>
          </el-form-item>
          <el-form-item label="示例文件">
            <a class="group-add-device" href="\static\example\sample.csv" download>批量绑定设备示例文件</a>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmGroupBindDevice()">确 定</el-button>
        <el-button @click="cancleBindGroupDevice()">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 申请正式授权 -->
    <el-dialog
      :title="`请添加${contractTitle}`"
      :visible.sync="contractVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :before-close="cancleContractForm"
      width="700px"
      class="contract-dialog">
      <div class="add-device-form add-contract-form">
        <el-form ref="contractForm">
          <el-form-item :label="`*${contractText}:`" ref="contract">
            <form-item-upload-file
              :validateFile="validateFileContract"
              :ErrorName="ErrorNameContract"
              :dialogVisible="contractVisible"
              :NeedConfirm="false"
              :twentyM="true"
              @validateInfoResult="contractValidateResult">
            </form-item-upload-file>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmApplyAuth()">提交审核</el-button>
        <el-button @click="cancleContractForm()">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="邮件列表"
      :visible.sync="mailReceiverVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :before-close="resetmailReceiverForm"
      width="700px">
      <div class="add-device-form">
        <el-form :model="mailReceiverData" :rules="rulesReceiver" ref="mailReceiverForm">
          <el-form-item prop="receiver" label="授权到期知会人">
            <el-input type="textarea" v-model="mailReceiverData.receiver" placeholder="授权到期前会邮件提醒，如有多个接收人请以;分隔" :maxlength="500"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitChangeMailReceiver()">确 定</el-button>
        <el-button @click="resetmailReceiverForm()">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import YoutuBoxDisplay from './js/YoutuBoxDisplay';
export default YoutuBoxDisplay;
</script>
<style lang='less'>
@import "../../../../../styles/btn.less";
@import "./css/youtubox-displayer.less";
</style>



// WEBPACK FOOTER //
// src/components/open/panels/application/panels/YoutuBoxDisplay.vue